import type { ShareButtonType } from 'src/interfaces';

export const SHARE_BUTTONS: ShareButtonType[] = ['copy'];
